export * from 'app/zdslogic-ui-shell/@fuse/services/config/config.module';
export * from 'app/zdslogic-ui-shell/@fuse/services/config/config.service';
